/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис подъездов
 */

/**
 * Сервис подъездов
 */
export class EntranceServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод создания подъезда.
   * Для ролей employee, owner можно сохранять только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * Метод доступен для: admin, service, owner, employee
   */
  PostEntrance = (req: PostEntranceRequestDto, init?: RequestInit): Promise<PostEntranceResponseDto> => {
    return fm.request<PostEntranceRequestDto, PostEntranceResponseDto>(`${this.host}/access_control/api/v1/entrance`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления подъезда.
   * Реализуется как удаление квартир по указанному дому и номеру подъезда.
   * Для ролей employee, owner можно удалять только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * Метод доступен для: admin, service, owner, employee
   */
  DeleteEntrance = (req: DeleteEntranceRequestDto, init?: RequestInit): Promise<DeleteEntranceResponseDto> => {
    return fm.request<DeleteEntranceRequestDto, DeleteEntranceResponseDto>(`${this.host}/access_control/api/v1/entrance/${encodeURIComponent(req.orpon)}/${encodeURIComponent(req.entranceNumber)}${fm.buildQuery(req, ["orpon","entranceNumber"])}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка подъездов.
   * При переданном company_ids учитывается тип связи компании и квартирограммы.
   * Если EntranceFilter.CompanyRelationType = DEVICE_SERVICE, то проверяется связка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE.
   * Если EntranceFilter.CompanyRelationType = MANAGEMENT, то проверяется связка в flatgramm_companies.
   * Если EntranceFilter.CompanyRelationType = DEFAULT, то проверяется связка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE.
   * Если EntranceFilter.CompanyRelationType = COMPANY_RELATION_TYPE_UNKNOWN, вернется ошибка валидации.
   * При не переданном company_ids поле EntranceFilter.CompanyRelationType вызовет ошибку валидации.
   * Для ролей employee, owner можно получать только подъезды квартирограмм, привязанные к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * Метод доступен для: admin, service, owner, employee
   */
  GetEntranceList = (req?: GetEntranceListRequestDto, init?: RequestInit): Promise<GetEntranceListResponseDto[]> => {
    return fm.list<GetEntranceListRequestDto, GetEntranceListResponseDto>(`${this.host}/access_control/api/v1/entrance/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод создания связи подъезда и устройства.
   * Для ролей employee, owner можно сохранять только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * EntranceDevice.RelationType в данном методе не используется.
   * Метод доступен для: admin, service, owner, employee
   */
  PutEntranceDeviceAttach = (req: PutEntranceDeviceAttachRequestDto, init?: RequestInit): Promise<PutEntranceDeviceAttachResponseDto> => {
    return fm.request<PutEntranceDeviceAttachRequestDto, PutEntranceDeviceAttachResponseDto>(`${this.host}/access_control/api/v1/entrance/${encodeURIComponent(req.entranceDevice.orpon)}/${encodeURIComponent(req.entranceDevice.entranceNumber)}/device/${encodeURIComponent(req.entranceDevice.deviceId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связи подъезда и устройства.
   * Для ролей employee, owner можно удалять только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * EntranceDevice.RelationType в данном методе не используется.
   * Метод доступен для: admin, service, owner, employee
   */
  PutEntranceDeviceDetach = (req: PutEntranceDeviceDetachRequestDto, init?: RequestInit): Promise<PutEntranceDeviceDetachResponseDto> => {
    return fm.request<PutEntranceDeviceDetachRequestDto, PutEntranceDeviceDetachResponseDto>(`${this.host}/access_control/api/v1/entrance/${encodeURIComponent(req.entranceDevice.orpon)}/${encodeURIComponent(req.entranceDevice.entranceNumber)}/device/${encodeURIComponent(req.entranceDevice.deviceId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связок подъезд-устройство.
   * Для ролей employee, owner можно получать только связи с подъездами квартирограмм, привязанным к домофонной компании пользователя (привязка компании с типом dc_company_flatgramm.type = DEVICE_SERVICE).
   * Метод доступен для: admin, service, owner, employee
   */
  GetEntranceDeviceList = (req?: GetEntranceDeviceListRequestDto, init?: RequestInit): Promise<GetEntranceDeviceListResponseDto[]> => {
    return fm.list<GetEntranceDeviceListRequestDto, GetEntranceDeviceListResponseDto>(`${this.host}/access_control/api/v1/entrance/device/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
}

/**
 * Тип связки
 */
export enum EntranceDeviceRelationType {
  /**
   * Значение не указано
   */
  RELATION_TYPE_UNKNOWN = "RELATION_TYPE_UNKNOWN",
  /**
   * Полная связь
   */
  FULL = "FULL",
  /**
   * Частичная связь
   */
  PARTIAL = "PARTIAL",
}
/**
 * Тип связки
 */
export type EntranceDeviceRelationTypeResponseEnum = keyof typeof EntranceDeviceRelationType
/**
 * Тип связки
 */
export type EntranceDeviceRelationTypeRequestEnum = Exclude<EntranceDeviceRelationTypeResponseEnum, "RELATION_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum EntranceDevicePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type EntranceDevicePagingDirectionTypeResponseEnum = keyof typeof EntranceDevicePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type EntranceDevicePagingDirectionTypeRequestEnum = Exclude<EntranceDevicePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum EntranceDevicePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По ОРПОНу и номеру подъезда
   */
  ORPON_THEN_ENTRANCE_NUMBER = "ORPON_THEN_ENTRANCE_NUMBER",
  /**
   * По идентификатору устройства
   */
  DEVICE_ID = "DEVICE_ID",
}
/**
 * Справочник типов значений сортировки.
 */
export type EntranceDevicePagingOrderByTypeResponseEnum = keyof typeof EntranceDevicePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type EntranceDevicePagingOrderByTypeRequestEnum = Exclude<EntranceDevicePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов связи компании с подъездами
 */
export enum EntranceFilterCompanyRelationType {
  /**
   * Значение не указано
   */
  COMPANY_RELATION_TYPE_UNKNOWN = "COMPANY_RELATION_TYPE_UNKNOWN",
  /**
   * Значение по умолчанию
   */
  DEFAULT = "DEFAULT",
  /**
   * Управляющая компания владеет квартирограммой
   */
  MANAGEMENT = "MANAGEMENT",
  /**
   * Домофонная компания обслуживает квартирограмму
   */
  DEVICE_SERVICE = "DEVICE_SERVICE",
}
/**
 * Справочник типов связи компании с подъездами
 */
export type EntranceFilterCompanyRelationTypeResponseEnum = keyof typeof EntranceFilterCompanyRelationType
/**
 * Справочник типов связи компании с подъездами
 */
export type EntranceFilterCompanyRelationTypeRequestEnum = Exclude<EntranceFilterCompanyRelationTypeResponseEnum, "COMPANY_RELATION_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum EntrancePagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type EntrancePagingDirectionTypeResponseEnum = keyof typeof EntrancePagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type EntrancePagingDirectionTypeRequestEnum = Exclude<EntrancePagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum EntrancePagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По ОРПОНу и номеру подъезда
   */
  ORPON_THEN_ENTRANCE_NUMBER = "ORPON_THEN_ENTRANCE_NUMBER",
}
/**
 * Справочник типов значений сортировки.
 */
export type EntrancePagingOrderByTypeResponseEnum = keyof typeof EntrancePagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type EntrancePagingOrderByTypeRequestEnum = Exclude<EntrancePagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос на удаление подъезда
 */
export type DeleteEntranceRequestDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumber: number
}
/**
 * Ответ на запрос удаления подъезда
 */
export type DeleteEntranceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка при удалении
   */
  readonly error: DeleteEntranceResponseErrorDto
}>
/**
 * Ошибка удаления подъезда
 */
export type DeleteEntranceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
  /**
   * Существуют связанные устройства
   */
  readonly linkedDevicesExists: DeleteEntranceResponseErrorLinkedDevicesExistsRequestDto
}>
/**
 * Ошибка удаления подъезда
 */
export type DeleteEntranceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
  /**
   * Существуют связанные устройства
   */
  readonly linkedDevicesExists: DeleteEntranceResponseErrorLinkedDevicesExistsDto
}>
/**
 * Существуют устройства, связанные с квартирами данного подъезда.
 * Следует отвязать устройства перед удалением подъезда
 */
export type DeleteEntranceResponseErrorLinkedDevicesExistsRequestDto = {
}
/**
 * Существуют устройства, связанные с квартирами данного подъезда.
 * Следует отвязать устройства перед удалением подъезда
 */
export type DeleteEntranceResponseErrorLinkedDevicesExistsDto = {
}
/**
 * Подъезд
 */
export type EntranceRequestDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumber: number
  /**
   * Номер начального помещения.
   * # Диапазон: 1..9999
   */
  startRoomNumber: number
  /**
   * Количество помещений на этаже.
   * # Диапазон: 1..1000
   */
  roomsCountPerFloor: number
  /**
   * Количество этажей.
   * # Диапазон: 1..100
   */
  floorsCount: number
}
/**
 * Подъезд
 */
export type EntranceResponseDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumber: number
  /**
   * Номер начального помещения.
   * # Диапазон: 1..9999
   */
  startRoomNumber: number
  /**
   * Количество помещений на этаже.
   * # Диапазон: 1..1000
   */
  roomsCountPerFloor: number
  /**
   * Количество этажей.
   * # Диапазон: 1..100
   */
  floorsCount: number
}
/**
 * Связка подъезда и устройства.
 * Реализуется через связь всех помещений в подъезде и устройства
 */
export type EntranceDeviceRequestDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumber: number
  /**
   * Идентификатор устройства.
   * # Диапазон: 1..2147483647
   */
  deviceId: number
}
/**
 * Связка подъезда и устройства.
 * Реализуется через связь всех помещений в подъезде и устройства
 */
export type EntranceDeviceResponseDto = {
  /**
   * ОРПОН дома
   */
  orpon: string
  /**
   * Номер подъезда.
   * # Диапазон: 1..100
   */
  entranceNumber: number
  /**
   * Идентификатор устройства.
   * # Диапазон: 1..2147483647
   */
  deviceId: number
  /**
   * Тип связки.
   * Игнорируется в методах создания и удаления связи
   */
  readonly relationType: EntranceDeviceRelationTypeResponseEnum
}
/**
 * Фильтр связок подъезд-устройство
 */
export type EntranceDeviceFilterRequestDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * По ОРПОН
   */
  orpons?: string[]
  /**
   * По номерам подъезда
   */
  entranceNumbers?: number[]
  /**
   * По идентификаторам привязанных устройств
   */
  deviceIds?: number[]
}
/**
 * Фильтр связок подъезд-устройство
 */
export type EntranceDeviceFilterResponseDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * По ОРПОН
   */
  orpons: string[]
  /**
   * По номерам подъезда
   */
  entranceNumbers: number[]
  /**
   * По идентификаторам привязанных устройств
   */
  deviceIds: number[]
}
/**
 * Постраничный вывод
 */
export type EntranceDevicePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType?: EntranceDevicePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: EntranceDevicePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type EntranceDevicePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType: EntranceDevicePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: EntranceDevicePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Фильтр подъездов
 */
export type EntranceFilterRequestDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds?: number[]
  /**
   * По ОРПОН
   */
  orpons?: string[]
  /**
   * По идентификаторам компаний
   */
  companyIds?: number[]
  /**
   * Тип связи компании с подъездами
   */
  companyRelationType?: EntranceFilterCompanyRelationTypeResponseEnum
}
/**
 * Фильтр подъездов
 */
export type EntranceFilterResponseDto = {
  /**
   * По идентификаторам квартирограмм
   */
  flatgrammIds: number[]
  /**
   * По ОРПОН
   */
  orpons: string[]
  /**
   * По идентификаторам компаний
   */
  companyIds: number[]
  /**
   * Тип связи компании с подъездами
   */
  companyRelationType: EntranceFilterCompanyRelationTypeResponseEnum
}
/**
 * Постраничный вывод
 */
export type EntrancePagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType?: EntrancePagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: EntrancePagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type EntrancePagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
   */
  orderByType: EntrancePagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: EntrancePagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос на получение связок подъезд-устройство
 */
export type GetEntranceDeviceListRequestDto = {
  /**
   * Фильтр по связкам подъезд-устройство
   */
  filter?: EntranceDeviceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: EntranceDevicePagingRequestDto
}>
/**
 * Ответ на запрос на получение списка связок подъезд-устройство
 */
export type GetEntranceDeviceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Связка подъезд-устройство
   */
  readonly data: EntranceDeviceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetEntranceDeviceListResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка связок подъезд-устройство
 */
export type GetEntranceDeviceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка связок подъезд-устройство
 */
export type GetEntranceDeviceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка подъездов
 */
export type GetEntranceListRequestDto = {
  /**
   * Фильтр по подъездам
   */
  filter?: EntranceFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: EntrancePagingRequestDto
}>
/**
 * Ответ на запрос на получение списка подъездов
 */
export type GetEntranceListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Подъезд
   */
  readonly data: EntranceResponseDto
  /**
   * Ошибка
   */
  readonly error: GetEntranceListResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка подъездов
 */
export type GetEntranceListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка подъездов
 */
export type GetEntranceListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения подъезда
 */
export type PostEntranceRequestDto = {
  /**
   * Подъезд
   */
  data: EntranceRequestDto
}
/**
 * Ответ на запрос сохранения подъезда
 */
export type PostEntranceResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Подъезд
   */
  readonly data: EntranceResponseDto
  /**
   * Ошибка при удалении
   */
  readonly error: PostEntranceResponseErrorDto
}>
/**
 * Ошибка сохранения подъезда
 */
export type PostEntranceResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка сохранения подъезда
 */
export type PostEntranceResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос создания связи подъезда и устройства
 */
export type PutEntranceDeviceAttachRequestDto = {
  /**
   * Связь подъезда и устройства
   */
  entranceDevice: EntranceDeviceRequestDto
}
/**
 * Ответ на запрос сохранения связи подъезда и устройства
 */
export type PutEntranceDeviceAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutEntranceDeviceAttachResponseErrorDto
}>
/**
 * Ошибка запроса на создание связи подъезда и устройства
 */
export type PutEntranceDeviceAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на создание связи подъезда и устройства
 */
export type PutEntranceDeviceAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления связи подъезда и устройства
 */
export type PutEntranceDeviceDetachRequestDto = {
  /**
   * Связь подъезда и устройства
   */
  entranceDevice: EntranceDeviceRequestDto
}
/**
 * Ответ на запрос удаления связи подъезда и устройства
 */
export type PutEntranceDeviceDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutEntranceDeviceDetachResponseErrorDto
}>
/**
 * Ошибка запроса на удаления связи подъезда и устройства
 */
export type PutEntranceDeviceDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на удаления связи подъезда и устройства
 */
export type PutEntranceDeviceDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на удаление подъезда
   */
  "DeleteEntranceRequest": {
    "kind": "class",
    "text": "Запрос на удаление подъезда",
    "fields": {
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер подъезда.
       * # Диапазон: 1..100
       */
      "entranceNumber": {
        "type": "int32",
        "text": "Номер подъезда.\n# Диапазон: 1..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления подъезда
   */
  "DeleteEntranceResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления подъезда",
    "fields": {
      /**
       * Ошибка при удалении
       */
      "error": {
        "type": "DeleteEntranceResponse.Error",
        "text": "Ошибка при удалении",
      },
    },
  },
  /**
   * Ошибка удаления подъезда
   */
  "DeleteEntranceResponse.Error": {
    "kind": "class",
    "text": "Ошибка удаления подъезда",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Существуют связанные устройства
       */
      "linkedDevicesExists": {
        "type": "DeleteEntranceResponse.Error.LinkedDevicesExists",
        "text": "Существуют связанные устройства",
      },
    },
  },
  /**
   * Существуют устройства, связанные с квартирами данного подъезда.
   * Следует отвязать устройства перед удалением подъезда
   */
  "DeleteEntranceResponse.Error.LinkedDevicesExists": {
    "kind": "class",
    "text": "Существуют устройства, связанные с квартирами данного подъезда.\nСледует отвязать устройства перед удалением подъезда",
  },
  /**
   * Подъезд
   */
  "Entrance": {
    "kind": "class",
    "text": "Подъезд",
    "fields": {
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер подъезда.
       * # Диапазон: 1..100
       */
      "entranceNumber": {
        "type": "int32",
        "text": "Номер подъезда.\n# Диапазон: 1..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Номер начального помещения.
       * # Диапазон: 1..9999
       */
      "startRoomNumber": {
        "type": "int32",
        "text": "Номер начального помещения.\n# Диапазон: 1..9999",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9999,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9999"
          },
        }
      },
      /**
       * Количество помещений на этаже.
       * # Диапазон: 1..1000
       */
      "roomsCountPerFloor": {
        "type": "int32",
        "text": "Количество помещений на этаже.\n# Диапазон: 1..1000",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 1000,
            "message": "Значение не входит в допустимый диапазон. Максимум: 1000"
          },
        }
      },
      /**
       * Количество этажей.
       * # Диапазон: 1..100
       */
      "floorsCount": {
        "type": "int32",
        "text": "Количество этажей.\n# Диапазон: 1..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
    },
  },
  /**
   * Связка подъезда и устройства.
   * Реализуется через связь всех помещений в подъезде и устройства
   */
  "EntranceDevice": {
    "kind": "class",
    "text": "Связка подъезда и устройства.\nРеализуется через связь всех помещений в подъезде и устройства",
    "fields": {
      /**
       * ОРПОН дома
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер подъезда.
       * # Диапазон: 1..100
       */
      "entranceNumber": {
        "type": "int32",
        "text": "Номер подъезда.\n# Диапазон: 1..100",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Идентификатор устройства.
       * # Диапазон: 1..2147483647
       */
      "deviceId": {
        "type": "int32",
        "text": "Идентификатор устройства.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип связки.
       * Игнорируется в методах создания и удаления связи
       */
      "relationType": {
        "type": "EntranceDevice.RelationType",
        "text": "Тип связки.\nИгнорируется в методах создания и удаления связи",
      },
    },
  },
  /**
   * Фильтр связок подъезд-устройство
   */
  "EntranceDeviceFilter": {
    "kind": "class",
    "text": "Фильтр связок подъезд-устройство",
    "fields": {
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * По ОРПОН
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОН",
      },
      /**
       * По номерам подъезда
       */
      "entranceNumbers": {
        "type": "int32",
        "text": "По номерам подъезда",
      },
      /**
       * По идентификаторам привязанных устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам привязанных устройств",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "EntranceDevicePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
       */
      "orderByType": {
        "type": "EntranceDevicePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ORPON_THEN_ENTRANCE_NUMBER",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "EntranceDevicePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр подъездов
   */
  "EntranceFilter": {
    "kind": "class",
    "text": "Фильтр подъездов",
    "fields": {
      /**
       * По идентификаторам квартирограмм
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По идентификаторам квартирограмм",
      },
      /**
       * По ОРПОН
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОН",
      },
      /**
       * По идентификаторам компаний
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний",
      },
      /**
       * Тип связи компании с подъездами
       */
      "companyRelationType": {
        "type": "EntranceFilter.CompanyRelationType",
        "text": "Тип связи компании с подъездами",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "EntrancePaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: ORPON_THEN_ENTRANCE_NUMBER
       */
      "orderByType": {
        "type": "EntrancePaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: ORPON_THEN_ENTRANCE_NUMBER",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "EntrancePaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос на получение связок подъезд-устройство
   */
  "GetEntranceDeviceListRequest": {
    "kind": "class",
    "text": "Запрос на получение связок подъезд-устройство",
    "fields": {
      /**
       * Фильтр по связкам подъезд-устройство
       */
      "filter": {
        "type": "EntranceDeviceFilter",
        "text": "Фильтр по связкам подъезд-устройство",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "EntranceDevicePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос на получение списка связок подъезд-устройство
   */
  "GetEntranceDeviceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка связок подъезд-устройство",
    "fields": {
      /**
       * Связка подъезд-устройство
       */
      "data": {
        "type": "EntranceDevice",
        "text": "Связка подъезд-устройство",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetEntranceDeviceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка связок подъезд-устройство
   */
  "GetEntranceDeviceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка связок подъезд-устройство",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка подъездов
   */
  "GetEntranceListRequest": {
    "kind": "class",
    "text": "Запрос получения списка подъездов",
    "fields": {
      /**
       * Фильтр по подъездам
       */
      "filter": {
        "type": "EntranceFilter",
        "text": "Фильтр по подъездам",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "EntrancePaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос на получение списка подъездов
   */
  "GetEntranceListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка подъездов",
    "fields": {
      /**
       * Подъезд
       */
      "data": {
        "type": "Entrance",
        "text": "Подъезд",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetEntranceListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка подъездов
   */
  "GetEntranceListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка подъездов",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения подъезда
   */
  "PostEntranceRequest": {
    "kind": "class",
    "text": "Запрос сохранения подъезда",
    "fields": {
      /**
       * Подъезд
       */
      "data": {
        "type": "Entrance",
        "text": "Подъезд",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения подъезда
   */
  "PostEntranceResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения подъезда",
    "fields": {
      /**
       * Подъезд
       */
      "data": {
        "type": "Entrance",
        "text": "Подъезд",
      },
      /**
       * Ошибка при удалении
       */
      "error": {
        "type": "PostEntranceResponse.Error",
        "text": "Ошибка при удалении",
      },
    },
  },
  /**
   * Ошибка сохранения подъезда
   */
  "PostEntranceResponse.Error": {
    "kind": "class",
    "text": "Ошибка сохранения подъезда",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос создания связи подъезда и устройства
   */
  "PutEntranceDeviceAttachRequest": {
    "kind": "class",
    "text": "Запрос создания связи подъезда и устройства",
    "fields": {
      /**
       * Связь подъезда и устройства
       */
      "entranceDevice": {
        "type": "EntranceDevice",
        "text": "Связь подъезда и устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи подъезда и устройства
   */
  "PutEntranceDeviceAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи подъезда и устройства",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutEntranceDeviceAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на создание связи подъезда и устройства
   */
  "PutEntranceDeviceAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на создание связи подъезда и устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления связи подъезда и устройства
   */
  "PutEntranceDeviceDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связи подъезда и устройства",
    "fields": {
      /**
       * Связь подъезда и устройства
       */
      "entranceDevice": {
        "type": "EntranceDevice",
        "text": "Связь подъезда и устройства",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи подъезда и устройства
   */
  "PutEntranceDeviceDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи подъезда и устройства",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutEntranceDeviceDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на удаления связи подъезда и устройства
   */
  "PutEntranceDeviceDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на удаления связи подъезда и устройства",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Тип связки
   */
  "EntranceDevice.RelationType": {
    "kind": "enum",
    "text": "Тип связки",
    "values": {
      /**
       * Значение не указано
       */
      "RELATION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Полная связь
       */
      "FULL": {
        "i": 1,
        "text": "Полная связь",
      },
      /**
       * Частичная связь
       */
      "PARTIAL": {
        "i": 2,
        "text": "Частичная связь",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "EntranceDevicePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "EntranceDevicePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По ОРПОНу и номеру подъезда
       */
      "ORPON_THEN_ENTRANCE_NUMBER": {
        "i": 1,
        "text": "По ОРПОНу и номеру подъезда",
      },
      /**
       * По идентификатору устройства
       */
      "DEVICE_ID": {
        "i": 2,
        "text": "По идентификатору устройства",
      },
    },
  },
  /**
   * Справочник типов связи компании с подъездами
   */
  "EntranceFilter.CompanyRelationType": {
    "kind": "enum",
    "text": "Справочник типов связи компании с подъездами",
    "values": {
      /**
       * Значение не указано
       */
      "COMPANY_RELATION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Значение по умолчанию
       */
      "DEFAULT": {
        "i": 1,
        "text": "Значение по умолчанию",
      },
      /**
       * Управляющая компания владеет квартирограммой
       */
      "MANAGEMENT": {
        "i": 2,
        "text": "Управляющая компания владеет квартирограммой",
      },
      /**
       * Домофонная компания обслуживает квартирограмму
       */
      "DEVICE_SERVICE": {
        "i": 3,
        "text": "Домофонная компания обслуживает квартирограмму",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "EntrancePaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "EntrancePaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По ОРПОНу и номеру подъезда
       */
      "ORPON_THEN_ENTRANCE_NUMBER": {
        "i": 1,
        "text": "По ОРПОНу и номеру подъезда",
      },
    },
  },
}